module.exports = __webpack_public_path__ + "img/green_spinner.19e4a2c3.gif";